import SyncableModel from './SyncableModel';
import Farm from './Farm';
import User from './User';
import Role from './Role';
import { getRootStore } from "../utils/root-store"

class FarmUser extends SyncableModel {
    static name = 'FarmUser'

    _table = 'farm_user'

    _fillable = [
      'id', 'user_id', 'farm_id', 'role_id', 'remark', 'state',
      'created_at', 'updated_at', 'deleted_at', 'synced_at'
    ]

    _casts = {
      user_id: 'integer',
      farm_id: 'integer',
      role_id: 'integer',
      state: 'object',
    }

    static _parents = ['farm'];

    static endpoint = '/farm_users'

    static allowReplaceUpdate = true

    relationUser() {
      return User.query().whereKey(this.user_id);
    }

    relationFarm() {
      return Farm.query().withoutGlobalScope('soft_delete').whereKey(this.farm_id);
    }

    relationRole() {
      return Role.query().whereKey(this.role_id);
    }

    static async syncAll(
      params = {}, sqlParams = [], cleanAfterSync = true,
      onSyncProgressUpdate = undefined, onError = undefined
    ) {
      const { userStore: { user } } = getRootStore();
      const _params = { ...params };
      const _sqlParams = [...sqlParams];
      if (user && user.role_id === 1 && !_params.farm_id__in) {
        _params.has = 'farm.farm_user';
      }
      return super.syncAll(_params, _sqlParams, cleanAfterSync, onSyncProgressUpdate, onError);
    }
}

Farm.FarmUser = FarmUser;
User.FarmUser = FarmUser;

export default FarmUser;
